export const HUBL_PATH = /{{-?\s*([a-zA-Z0-9_()\-[\]]+(?:[.][a-zA-Z0-9_()\-[\]]+)*)\s*-?}}/g;
export const HUBL_PERSONALIZATION_PATTERN = /{{-?\s*personalization_token\(\s*["']([a-zA-Z0-9_()\-[\]]+(?:[.][a-zA-Z0-9_()\-[\]]+)*)["']\s*,\s*["'](.*?)["']{1}\s*\)\s*-?}}/g;
export const FILTER_PATTERN_FRAGMENT = '(?:\\|(.*?))?';
export const hsDataTokenConfig = {
  HIDE_SITE_SETTINGS_CATEGORY: 'hideSiteSettingsCategory',
  INCLUDE_SUBSCRIPTION_TYPE_CATEGORY: 'includeSubscriptionTypeCategory',
  INCLUDE_INTERNAL_CONTACT_RECORD: 'includeInternalContactRecord',
  INCLUDE_USER_OBJECT_PROPERTIES: 'includeUserObjectProperties',
  ALLOW_EMPTY_FALLBACKS: 'allowEmptyFallbacks',
  IS_EMAIL: 'isEmail',
  HIDE_FALLBACKS: 'hideFallbacks',
  SUPPORTED_CRM_OBJECT_FQNS: 'supportedCrmObjectFQNs',
  CUSTOM_OBJECT_PREFIXES: 'customObjectPrefixes',
  USE_FLEXIBLE_ASSOCIATIONS: 'useFlexibleAssociations',
  PROPERTY_FILTERS_CALLBACK: 'propertyFiltersCallback',
  USE_AS_UPGRADE_POINT: 'useAsUpgradePoint',
  TOKEN_PATHS_CONTENT_CONTEXT: 'dataTokenContentContext',
  UNSUPPORTED_TOKENS: 'unsupportedTokens',
  UNSUPPORTED_DATA_TOKEN_PATHS: 'unsupportedDataTokenPaths',
  RENDER_DATA_TOKEN_POPOVER: 'renderDataTokenPopover',
  USE_DEFAULT_LABEL_FOR_CRM_OBJECT_TYPES: 'useDefaultLabelForCrmObjectTypes',
  MAX_TOKEN_WIDTH: 'maxTokenWidth',
  DATA_TOKEN_POPOVER_PLACEMENT: 'dataTokenPopoverPlacement'
};